import Cookies from 'js-cookie';
import { GSERVICE_URL } from 'src/constants';
// import { WEB_NAME } from 'src/constants/layout';
import { timestamp } from 'src/utils/helper';

export const getCountviews = async (_id) => {
  if (!_id) return null;

  const _ga = await Cookies.get('_ga');
  const _gid = await Cookies.get('_gid');
  const params = {
    site: 'khobsanam',
    ga: _ga,
    gid: _gid,
    newsid: _id,
    timestamp: timestamp()
  };
  const uri = `${GSERVICE_URL}/cpvs`;
  try {
    const res = await fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    const resData = await res.json();
    if (resData) return resData;
  } catch (err) {
    console.error(`${timestamp()}==========> GET_COUNTVIEWS ERROR : ${uri}`, err);
  }
};
